import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo } from "react";
import { OrderLayout } from "@/components/Package/OrderComponents/OrderLayout";
import { PassCategory } from "../../../api/membership";
import { useRouter } from "next/router";
import { useProductOrder } from "@/components/Package/OrderComponents/useProductPayment";
import { useQuery } from "@tanstack/react-query";
import { getPackage } from "../../../api/package";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { CheckSolvookPlus } from "@/components/Books/Order/CheckSolvookPlus";
const OrderPage = ()=>{
    const { query , back  } = useRouter();
    const packageId = (query === null || query === void 0 ? void 0 : query.id) ? parseInt(query.id) : undefined;
    const { handleOrder , payMethod , handlePayMethod  } = useProductOrder({
        orderType: PassCategory.Package,
        productId: packageId,
        // postbackURL: PACKAGE_ORDER_COMPLETE.concat(`/${packageId}`),
        completePage: true
    });
    const { data: packageItem , isError  } = useQuery([
        "package",
        "order",
        packageId
    ], ()=>getPackage(packageId), {
        enabled: !!packageId
    });
    const productInfo = useMemo(()=>{
        if (!packageItem) return;
        return {
            title: packageItem.title,
            price: packageItem.price,
            originalPrice: packageItem.originalPrice,
            category: PassCategory.Package,
            id: packageItem.id,
            description: packageItem.description,
            descriptionTitle: "패키지 유의사항 "
        };
    }, [
        packageItem
    ]);
    const handleSubmit = useCallback(async (ev)=>{
        ev.preventDefault();
        mixpanelEvent("Purchase Button Clicked", {
            "Product Categories": productInfo.category,
            "Product ID": productInfo.id,
            "Product Title": productInfo.title,
            "Product Price": productInfo.price
        });
        const mixpanelMemoKey = "mixpanel-books-order";
        sessionStorage.setItem(mixpanelMemoKey, JSON.stringify({
            "Payment Method": payMethod,
            "# of Products ": 1,
            "Product IDs": [
                productInfo.id
            ],
            "Product Categories": [
                productInfo.category
            ],
            "Product Names": productInfo.title,
            Subtotal: productInfo.price,
            "Order Total": productInfo.price,
            "Product Variants": []
        }));
        handleOrder(ev);
    }, [
        productInfo,
        payMethod
    ]);
    useEffect(()=>{
        if (isError) back();
    }, [
        isError
    ]);
    const hasExpert = useMemo(()=>{
        var _packageItem_component;
        if (!packageItem) return false;
        return (_packageItem_component = packageItem.component) === null || _packageItem_component === void 0 ? void 0 : _packageItem_component.expert;
    }, [
        packageItem
    ]);
    if (!packageItem) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            hasExpert && /*#__PURE__*/ _jsx(CheckSolvookPlus, {}),
            /*#__PURE__*/ _jsx(OrderLayout, {
                PageTitle: "패키지 결제",
                productInfo: productInfo,
                errorCode: 200,
                handleChange: handlePayMethod,
                handleSubmit: handleSubmit,
                payMethod: payMethod
            })
        ]
    });
};
export default OrderPage;
